const FB_PHOTOSHOOTS = '343581972800903';
const FB_PHOTOGRAPHY = '464912960269071';

function setHref(selector: string, href: string): HTMLAnchorElement | null {
    const el = document.querySelector<HTMLAnchorElement>(selector);
    if (el) el.href = href;
    return el;
}

export function applyMobileSocialLinks(): void {
    const ua = navigator.userAgent;
    const ogTitle = document
        .querySelector<HTMLMetaElement>('meta[property="og:title"]')
        ?.content;
    const isPhotoshoots = ogTitle === 'Clepta Photoshoots';
    const fbId = isPhotoshoots ? FB_PHOTOSHOOTS : FB_PHOTOGRAPHY;
    const fbFallback = isPhotoshoots
        ? 'https://www.facebook.com/CleptaPhotoshoots'
        : 'https://www.facebook.com/CleptaPhotography';

    if (/Android/i.test(ua)) {
        setHref(
            '#facebook-link',
            `intent://page/${fbId}#Intent;package=com.facebook.katana;scheme=fb;S.browser_fallback_url=${fbFallback};end`,
        );
        setHref(
            '#instagram-link',
            'intent://instagram.com/_u/cleptaphotography#Intent;package=com.instagram.android;scheme=https;S.browser_fallback_url=https://www.instagram.com/cleptaphotography;end',
        );
    } else if (/iPhone|iPad/i.test(ua)) {
        const fb = setHref('#facebook-link', `fb://profile/${fbId}`);
        fb?.addEventListener('click', () => {
            setTimeout(() => {
                window.location.href = fbFallback;
            }, 500);
        });
        const ig = setHref(
            '#instagram-link',
            'instagram://user?username=cleptaphotography',
        );
        ig?.addEventListener('click', () => {
            setTimeout(() => {
                window.location.href = 'https://www.instagram.com/cleptaphotography';
            }, 500);
        });
    }
}
